const Quantity = () => {
    const quantities = document.querySelectorAll('.quantity');

    quantities.forEach(quantity => {
        const input = quantity.querySelector('input.qty');
        const plusBtn = quantity.querySelector('.qty-btn--plus');
        const minusBtn = quantity.querySelector('.qty-btn--minus');

        if (input && plusBtn && minusBtn) {

            // Parsowanie atrybutów
            const step = parseFloat(input.getAttribute('step')) || 1;
            const min = parseFloat(input.getAttribute('min')) || 0;
            const max = parseFloat(input.getAttribute('max')) || Infinity;

            plusBtn.addEventListener('click', () => {
                let value = parseFloat(input.value) || 0;

                if (value + step <= max) {
                    input.value = (value + step).toFixed(0);
                } else {
                    input.value = max;
                }

                input.dispatchEvent(new Event('change', { bubbles: true }));
            });

            minusBtn.addEventListener('click', () => {
                let value = parseFloat(input.value) || 0;

                if (value - step >= min) {
                    input.value = (value - step).toFixed(0);
                } else {
                    input.value = min;
                }

                input.dispatchEvent(new Event('change', { bubbles: true }));
            });

            input.addEventListener('input', () => {
                let value = parseFloat(input.value) || 0;

                if (value < min) {
                    input.value = min;
                } else if (value > max) {
                    input.value = max;
                }
            });
        }
    });

}

export default Quantity;